import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public router: Router, private http: HttpClient) {}

  canActivate(): Observable<boolean> {
    return this.http
      .get(environment.API_BASE + 'validateSession', { withCredentials: true })
      .pipe(
        map(() => {
          // Cookie is valid but localStorage may have been cleared —
          // if critical user data is missing, force re-login to repopulate it
          if (!localStorage.getItem('name') || !localStorage.getItem('user_id')) {
            localStorage.clear();
            this.router.navigate(['login']);
            return false;
          }
          return true;
        }),
        catchError((error) => {
          // Only clear localStorage and force login on 401 (actual auth failure)
          // Not on network errors or 5xx — those are transient and should not wipe the session
          if (error.status === 401) {
            localStorage.clear();
            this.router.navigate(['login']);
          }
          return of(false);
        })
      );
  }
}
